// Carrello unificato "Maxi Experience" (Fase 3) + Ordini cliente + Report Admin.
// Riusa l'istanza axios centrale (Bearer + refresh) tramite ./client.
import { api, unwrap } from './client';

export const cartService = {
  addBooking: (kind, payload) => unwrap(api.post(`/customer/cart/booking/${kind}`, payload)),
  /** Catalogo unificato REALE (esperienze + escursioni + servizi). */
  getCatalog: () => unwrap(api.get('/customer/cart/catalog')),
  /** Carrello corrente + anteprima calcolo (prezzo autoritativo server-side). */
  getCart: (redeemPoints = 0) =>
    unwrap(api.get('/customer/cart', { params: { redeem_points: redeemPoints } })),
  /** Aggiunge una voce di catalogo al carrello. */
  addItem: (catalogId, qty = 1) =>
    unwrap(api.post('/customer/cart/items', { catalog_id: catalogId, qty })),
  /** Esperienze correlate (Fase C · cross-sell) per zona del soggiorno/tavolo in carrello. */
  getSuggestions: (limit = 4) =>
    unwrap(api.get('/customer/cart/suggestions', { params: { limit } })),
  /** Aggiunge un soggiorno (camera hotel) al carrello CON hold temporaneo (Fase A). */
  addStay: (payload) => unwrap(api.post('/customer/cart/stay', payload)),
  /** Aggiunge una prenotazione tavolo (ristorante) al carrello con caparra opzionale (Fase B). */
  addTable: (payload) => unwrap(api.post('/customer/cart/table', payload)),
  /** Aggiunge un PRODOTTO E-Commerce al carrello comune. payload: {owner_id, product_id, variant_id?, qty?} */
  addProduct: (payload) => unwrap(api.post('/customer/cart/product', payload)),
  /** Applica un coupon E-Commerce (per negozio). */
  applyCoupon: (ownerId, code) => unwrap(api.post('/customer/cart/coupon', { owner_id: ownerId, code })),
  /** Rimuove il coupon di un negozio. */
  removeCoupon: (ownerId) => unwrap(api.delete(`/customer/cart/coupon/${ownerId}`)),
  /** Aggiorna la quantita' di una riga (qty<=0 rimuove). */
  updateItem: (itemId, qty) => unwrap(api.put(`/customer/cart/items/${itemId}`, { qty })),
  /** Rimuove una riga dal carrello. */
  removeItem: (itemId) => unwrap(api.delete(`/customer/cart/items/${itemId}`)),
  /** Svuota il carrello. */
  clear: () => unwrap(api.delete('/customer/cart')),
  /** Checkout MOCK: crea ordine, accredita/riscatta punti, svuota carrello. */
  checkout: (redeemPoints = 0, shippingAddress = null) =>
    unwrap(api.post('/customer/cart/checkout', { redeem_points: redeemPoints, shipping_address: shippingAddress || {} })),
};

/** Trip Planner — compone/salva/condivide un itinerario (auth opzionale). Predisposto per l'AI. */
export const tripService = {
  plan: (intent) => unwrap(api.post('/customer/trip/plan', intent || {})),
  save: (plan) => unwrap(api.post('/customer/trip/save', { plan })),
  getShared: (token) => unwrap(api.get(`/customer/trip/shared/${token}`)),
  mine: () => unwrap(api.get('/customer/trip/mine')),
  remove: (token) => unwrap(api.delete(`/customer/trip/${token}`)),
};

export const ordersService = {
  /** Storico ordini del cliente loggato. */
  list: (limit = 50) => unwrap(api.get('/customer/orders', { params: { limit } })),
  /** Dettaglio di un ordine. */
  get: (oid) => unwrap(api.get(`/customer/orders/${oid}`)),
};

export const platformReportService = {
  /** Report piattaforma (Admin): vendite, commissioni, beneficenza, punti, payout. */
  getPlatform: () => unwrap(api.get('/admin/reports/platform')),
};

